import dayjs from "dayjs";


const initTimeSerieTiming = (field) => {
    field.currentValue = {};

    field.currentValue = field.value;
    field.currentValue.value.start_date.value = (field.currentValue.value.start_date.value) ? dayjs(field.currentValue.value.start_date.value) : null;
    field.currentValue.value.end_date.value = (field.currentValue.value.end_date.value) ? dayjs(field.currentValue.value.end_date.value): null;
    field.currentValue.value.periodicity.value = (field.value.value.periodicity.value) ? field.value.value.periodicity.value : 'null',

    field.complete = false;
    field.start_dateStore = {};
    field.end_dateStore = {};

    field.start_dateStore.isOpen = false;
    field.end_dateStore.isOpen = false;
}

function getEndOfPeriod(dateString: string, periodicity: string): string {
  if (!dateString || !/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return '';
  }
  const [year, month] = dateString.split('-').map(Number);

  if (isNaN(year) || isNaN(month)) {
    return '';
  }

  let endMonth: number;
  let endYear: number = year;

  switch (periodicity) {
    case 'quarterly':
      // Q1: Jan-Mar -> March, Q2: Apr-Jun -> June, Q3: Jul-Sep -> September, Q4: Oct-Dec -> December
      endMonth = Math.ceil(month / 3) * 3;
      break;
    case 'semi-annually':
      // H1: Jan-Jun -> June, H2: Jul-Dec -> December
      endMonth = month <= 6 ? 6 : 12;
      break;
    case 'annually':
      // Always end of December
      endMonth = 12;
      break;
    case 'monthly':
    default:
      // End of the current month
      endMonth = month;
      break;
  }

  const lastDayOfPeriod = new Date(endYear, endMonth, 0);

  const yyyy = lastDayOfPeriod.getFullYear();
  const mm = String(lastDayOfPeriod.getMonth() + 1).padStart(2, '0');
  const dd = String(lastDayOfPeriod.getDate()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}`;
}
const initTimeSerie = (field) => {
    // Get periodicity from timing, default to 'monthly'
    const periodicity = field.value.value.timing?.periodicity?.value || 'monthly';

    // Converts dict to list (pandas migration related)
    if (typeof field.value.value.data == 'object' && !Array.isArray(field.value.value.data)) {
        const formattedList = [];

        if (Object.keys(field.value.value.data).length !== 0) {
            Object.entries(field.value.value.data).map(([date, value]) => {
                formattedList.push({
                    'date': {
                        'value': date,
                        'address': null,
                    },
                    'end_of_period': {
                        'value': getEndOfPeriod(date, periodicity),
                        'address': null,
                    },
                    'value': {
                        'value': value,
                        'address': null,
                    }
                })
            })
        }

        field.value.value.data = formattedList;
    }

    field.currentValue = field.value;

    field.start_dateStore = {};
    field.end_dateStore = {};

    if (field.value.value.timing !== undefined) {
        field.currentValue.value.timing.periodicity.value = (field.value.value.timing.periodicity.value) ? field.value.value.timing.periodicity.value : 'null';
        field.currentValue.value.timing.start_date.value = (field.value.value.timing.start_date.value) ? dayjs(field.value.value.timing.start_date.value) : null;
        field.currentValue.value.timing.end_date.value = (field.value.value.timing.end_date.value) ? dayjs(field.value.value.timing.end_date.value) : null
    }

    field.start_dateStore.isOpen = false;
    field.end_dateStore.isOpen = false;
    field.currentValue.timingChoice = 'null';
}

const initCustomizableTimingReference = (field) => {
    field.currentValue = field.value;

    field.start_dateStore = {};
    field.end_dateStore = {};

    if (field.value.value && field.value.value.timing !== undefined) {
        field.currentValue.value.timing.periodicity.value = (field.value.value.timing.periodicity.value) ? field.value.value.timing.periodicity.value : 'null';
        field.currentValue.value.timing.start_date.value = (field.value.value.timing.start_date.value) ? dayjs(field.value.value.timing.start_date.value) : null;
        field.currentValue.value.timing.end_date.value = (field.value.value.timing.end_date.value) ? dayjs(field.value.value.timing.end_date.value) : null
    }

    field.start_dateStore.isOpen = false;
    field.end_dateStore.isOpen = false;
    field.currentValue.timingChoice = 'null';
}

const initList = (field) => {
    field.currentValue = field.value;

    if (!Array.isArray(field.currentValue?.value)) {
        field.currentValue = { ...field.currentValue, value: [] };
        return;
    }

    field.currentValue.value.map((e: any) => {
        Object.keys(e).map((key) => {
            if (key !== 'id' && field.elems?.[key]) {
                if (field.elems[key].type === 'relation') {
                    e[key].value = (e[key].value) ? e[key].value : 'null';
                } else if (field.elems[key].type === 'datetime') {
                    field.elems[key].isOpen = false;
                    e[key].value = (e[key].value) ? dayjs(e[key].value) : null;
                } else if (field.elems[key].type === 'float') {
                    e[key].value = (e[key].value) ? e[key].value : null;
                }
            }
        })

    })
}

const initRelation = (field) => {
    field.currentValue = field.value;
    if (field.currentValue.value === null) {
        field.currentValue.value = 'null';
    }
    field.currentValue.relationChoice = 'null'
}

const initEnum = (field) => {
    field.currentValue = field.value;
    if (field.currentValue.value === null) {
        field.currentValue.value = 'null';
    }
}

const initTimingReference = (field) => {
    field.currentValue = field.value;
    if (field.currentValue.value === null) {
        field.currentValue.value = 'null';
    }
    field.currentValue.timingChoice = 'null';
}

const initDate = (field) => {
    field.currentValue = field.value;
    field.currentValue.value = field.value.value ? dayjs(field.value.value) : null;
    field.store = {};
    field.store.isOpen = false;
}

const initStd = (field) => {
    field.currentValue = field.value;
}

const initFloat = (field) => {
    field.currentValue = field.value;
}


const TYPES_TO_FUNC = {
    'time_serie': initTimeSerie,
    'time_serie_timing': initTimeSerieTiming,
    'enum': initEnum,
    'datetime': initDate,
    'list': initList,
    'relation': initRelation,
    'bool': initStd,
    'str': initStd,
    'int': initStd,
    'float': initFloat,
    'timing_reference': initTimingReference,
    'customizable_timing_reference': initCustomizableTimingReference,
}


const FieldsInitializer = (fields) => {
    if (!fields || typeof fields !== 'object') return fields;

    Object.entries(fields).map(([name, field]: Array<string|any>) => {
        if (field.type in TYPES_TO_FUNC) {
            try {
                TYPES_TO_FUNC[field.type](field);
            } catch (err) {
                console.error(`FieldsInitializer: failed to init field "${name}" (type=${field.type})`, err);
                field.currentValue = field.value ?? { value: null };
            }
        }
    })
    return fields
}


export default FieldsInitializer
export { initDate, initEnum, initTimeSerie, initTimeSerieTiming, initList, initRelation, getEndOfPeriod }
